<h1 class="page-title">Pantomim csapat</h1>

<!--img:kenes-->
<h2>Szolgálatunk célja</h2>

<p>
  Gyülekzetünk sok féle módon, sok féle módszerrel igyekszik Isten örömhírét, az evangéliumot hirdetni az embereknek
  Kaposvár városban, és azon kívül is. A pantomim színjátékot is ezzel a céllal tanuljuk meg, és adjuk elő sok felé,
  hogy láthassák minél többen azok közül, akik még nem fogadták el az új mennyei életüket.
  Ezen kívül egy csodálatos időtöltés a fiataljainkkal, szeretetben és mindabban, amit az Úr Jézus adott nekünk, hogy
  egyre inkább meglássuk: Isten gyermekei vagyunk.
</p>

<h2>Hogyan érsz el bennünket?</h2>

<!--<p>-->
  <!--img:Life house Jelenet a Lifehouse c. darabból-->
  <!--Szeretettel várunk minden előadásunkra!-->
<!--</p>-->

<p>
  Előfordul, hogy nem tudunk kimenni a Kossuth térre. Az alább látható elérhetőségen keresztül bármikor meg lehet
  érdeklődni, hogy lesz-e előadás. Szintén ezen a telefonszámon lehet megbeszélni esetleges meghívásokat, felkéréseket.
</p>

<!--<p>-->
  <!--Szívesen látunk mindig!-->
<!--</p>-->

<!--<p>-->
  <!--img:kossuth teren A Kossuth téren játszik a csapat-->
<!--</p>-->

<p>
  A szolgálat vezetője:
  <strong>Csillag László</strong>
  +36-30-924-6090
</p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/pantomime/pantomime.component.html